export class PixLimitsReturn {
	valorMaximo: number;
	tipo: PixLimitsReturnTipo;
	valor: number;
	faixaHorario: FaixaHorario;
}

export enum PixLimitsReturnTipo {
	PIX_MESMA_TITULATIDADE = 'PIX_MESMA_TITULATIDADE',
	PIX_FAVORECIDOS = 'PIX_FAVORECIDOS',
	PIX_NAO_FAVORECIDOS = 'PIX_NAO_FAVORECIDOS',
	PIX_QRCODE = 'PIX_QRCODE',
	PIX_FORA_HORARIO = 'PIX_FORA_HORARIO',
	PIX_DIURNO = 'PIX_DIURNO',
	PIX_NOTURNO = 'PIX_NOTURNO',
}

export class FaixaHorario {
	public horarioInicial: string;
	public horarioFinal: string;
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/pix/models/limits-return.model.ts